export const STORAGE_KEY_PREFIX = 'quarantineTableConfig';

const getKey = (key: string) => `${STORAGE_KEY_PREFIX}.${key}`;

export const saveConfigToLocalStorage = (value: any, key: string) => {
  localStorage.setItem(getKey(key), JSON.stringify(value));
};

export const loadConfigFromLocalStorage = (defaultValue: any, key: string) => {
  try {
    const stored = localStorage.getItem(getKey(key));
    return stored ? JSON.parse(stored) : defaultValue;
  } catch (e) {
    console.error('Failed to load from localStorage:', e);
    return defaultValue;
  }
};
